import React from "react";
import { CardList } from "@panda0/panda0-ui";
import { FileText } from "lucide-react";

const QuizResults = ({ pandaQuizRef, questions }) => {
  // Calculate overall score
  const calculateOverallScore = () => {
    let totalScore = 0;
    let maxScore = 0;

    questions.forEach((question) => {
      // Find the highest possible score for this question
      const maxPossibleScore = Math.max(
        ...question.options.map((opt) => opt.score)
      );
      maxScore += maxPossibleScore;

      // Assume the user selected the option with score 8 (second best) for simplicity
      // In a real app, you'd use the actual user selection
      const selectedScore = 8;
      totalScore += selectedScore;
    });

    return Math.round((totalScore / maxScore) * 100);
  };

  const overallScore = calculateOverallScore();

  return (
    <div id="result" ref={pandaQuizRef} className="pb-10 pt-6 border-t">
      <div className="flex items-center mb-6">
        <div className="h-8 w-8 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center mr-3">
          <FileText className="h-4 w-4" />
        </div>
        <h2 className="text-xl font-bold">PandaQuiz Results</h2>
      </div>

      {/* Score Overview */}
      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-8">
        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-green-600">
            {overallScore}%
          </div>
          <div className="text-sm text-neutral-500 mt-1">Overall Score</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-blue-600">
            {questions.length}
          </div>
          <div className="text-sm text-neutral-500 mt-1">Questions</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-purple-600">28:45</div>
          <div className="text-sm text-neutral-500 mt-1">Time Taken</div>
        </CardList.Card>

        <CardList.Card outerClassName="border rounded-lg shadow-sm p-4 flex flex-col items-center justify-center">
          <div className="text-3xl font-bold text-orange-600">4.5/5</div>
          <div className="text-sm text-neutral-500 mt-1">Difficulty</div>
        </CardList.Card>
      </div>
    </div>
  );
};

export default React.memo(QuizResults);
